export const blockIconsCommonactionsBugReportNew = (
	<span className='material-symbols-outlined'>bug_report</span>
);
